import script from "./QVideoCustom.vue?vue&type=script&lang=ts&setup=true"
export * from "./QVideoCustom.vue?vue&type=script&lang=ts&setup=true"

import "./QVideoCustom.vue?vue&type=style&index=0&id=8a00f9de&lang=scss"

const __exports__ = script;

export default __exports__